import { SxProps, Theme } from "@mui/material";

import { SxStyle } from "../../types/style";

// CONTENT

const contentStack: SxProps<Theme> = {
  height: { xs: "fitContent", md: "70vh" },
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  // minHeight:"85vh",
  backgroundImage: "linear-gradient(180deg, #541554 0%, #4A144E 100%)",
  padding: { xs: "none", md: "0 1%" },
  width: "100%",
  gap: { xs: "0", md: "150px" },
  flexDirection: { xs: "column", md: "row" },
};

const contentStackBoxImg: SxProps<Theme> = {
  width: "100%",
  height: { xs: "auto", lg: "110%" },
  // marginTop: '5px',
  // marginLeft: '1vh',
  // maxHeight: '800px',
  // maxWidth: '800px',
};

const contentStackBoxImgByPass: SxProps<Theme> = {
  width: { xs: "100%", sm: "65%", lg: "61%" },
  height: { xs: "auto", lg: "100%" },
};

const contentStackBox: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  color: "#fff",
  width: { xs: "100%", md: "auto" },
  boxSizing: "border-box",
};

const contentStackBoxTypography1: SxProps<Theme> = {
  fontFamily: "Open Sans,sans-serif",
  fontWeight: 600,
  lineHeight: 1.4,
  fontSize: { xs: "48px", xl: "80px" },
  textAlign: { xs: "center", md: "center" },
  position: "relative",
  top: 0,
  left: { xs: "50%", md: "0" },
  transform: { xs: "translateX(-50%)", md: "none" },
  width: { xs: "265px", sm: "auto" },
  marginTop: { xs: "20px", md: "0px" },
  color: "#ECB22E",
};

const contentStackBoxTypography2: SxProps<Theme> = {
  textAlign: { xs: "center", md: "center" },
  position: "relative",
  fontFamily: "Open Sans Semibold,sans-serif",
  fontSize: { xs: "24px", xl: "40px" },
  fontWeight: 300,
  top: 0,
  left: { xs: "50%", md: "0" },
  transform: { xs: "translateX(-50%)", md: "none" },
  width: { xs: "300px", sm: "100%" },
  height: 44,
  marginBottom: "10px",
};

const contentStackBoxDivider: SxProps<Theme> = {
  minHeight: "35px",
  marginBottom: "1rem",
  border: "none",
};

const contentStackBoxLoginButton: SxProps<Theme> = {
  height: { xs: "41px", xl: "75px" },
  textTransform: "none",
  borderRadius: "6px",
  display: "flex",
  gap: "12px",
  color: "#5E5E5E",
  width: { xs: "248px", xl: "410px" },
  position: "relative",
  top: 0,
  left: "50%", // Center horizontally
  transform: "translateX(-50%)", // Center horizontally
  textAlign: "center", // Center text within its container
};

const contentStackBoxRegisterButton: SxProps<Theme> = {
  height: "45px",
  padding: "1px 6px",
  borderRadius: "6px",
  border: "3px solid #028ed5",
  color: "#fff",
  background: "transparent",
  width: "248px",
  position: "relative",
  top: 0,
  left: { xs: "50%", md: "0" },
  transform: { xs: "translateX(-50%)", md: "none" },
  ":hover": {
    backgroundColor: "#a6cbcc",
    color: "#4f4f4f",
  },
};

// MODAL LOGIN

const modalLogin: SxStyle = {
  position: "absolute",
  width: "320px",
  height: "407px",
  background: "white",
  borderRadius: "6px",
};

const modalLoginStack1: SxStyle = {
  p: "16px",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  borderBottom: "1px solid #c8ced3",
};

const modalLoginStack2: SxStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};

const modalLoginStack3: SxStyle = {
  p: "0px 16px 16px 16px ",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
};

const modalLoginButton: SxStyle = {
  width: "100%",
  borderRadius: "6px",
  fontSize: "14px",
  paddingY: "10px",
};

const modalLoginButtonText: SxStyle = {
  fontSize: { xs: "12px", sm: "14px" },
  lineHeight: 1.6,
  fontWeight: 600,
};

const modalLoginInput: SxStyle = {
  background: "white",
  width: "100%",
  height: "38px",
  borderRadius: "6px",
  fontSize: "14px",
  outline: "none",
  "& fieldset": { border: "1px solid rgba(0,0,0,10%)" },
  "& input": { border: "none" },
  "&.Mui-focused fieldset": {
    borderColor: "rgba(0,0,0,40%)",
  },
};

const contentLogoutImg: SxProps<Theme> = {
  width: { xs: "260px", sm: "365px" },
  height: { xs: "200px", sm: "298px" },
  marginBottom: "64px",
};

const newContentStack: SxProps<Theme> = {
  height: { xs: "fitContent", md: "70vh", xl: "79vh" },
  display: "flex",
  alignItems: "center",
  backgroundImage: "linear-gradient(180deg, #541554 0%, #4A144E 100%)",
  width: "100%",
  gap: { xs: "0", md: 0 },
  flexDirection: { xs: "column", md: "row" },
};

const newContainerForm: SxProps<Theme> = {
  width: { xs: "100%", md: "50%", xl: "40%" },
};
const newContainerImage: SxProps<Theme> = {
  width: { xs: "100%", md: "50%", xl: "60%" },
};

export const loginStyle = {
  contentStack,
  contentStackBox,
  contentStackBoxTypography1,
  contentStackBoxTypography2,
  contentStackBoxDivider,
  contentStackBoxLoginButton,
  contentStackBoxRegisterButton,
  contentStackBoxImg,
  contentStackBoxImgByPass,
  modalLogin,
  modalLoginStack1,
  modalLoginStack2,
  modalLoginStack3,
  modalLoginButton,
  modalLoginButtonText,
  modalLoginInput,
  contentLogoutImg,
  newContentStack,
  newContainerForm,
  newContainerImage,
};
